import { useState } from "react";
import "./css/menuPop.less";

const DropdownMenu = ({ title = "JuChain Mainnet", textList = ['JuChain Mainnet','JuChain Testnet'], onChildMenuAction }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleChildMenuAction = (index) => {
    if(!title) {
      let langtype = index == 0?'en':'zh'
      onChildMenuAction?.(langtype);
    }else{
      onChildMenuAction?.(textList[index], index);
    }
    setShowMenu(false);
  };

  return (
    <div
      className="item"
      onClick={(e) => {
        e.stopPropagation();
        setShowMenu(true);
      }}
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
    >
      {title ? (
        <div className="name" style={{ color: showMenu ? "#23D8F0" : "" }}>
          {title}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            style={{ transform: showMenu ? "rotate(180deg)" : "", transition: "all .3s" }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.41107 6.91075C4.73651 6.58533 5.26414 6.58533 5.58958 6.91075L10.0003 11.3215L14.4111 6.91075C14.7365 6.58533 15.2642 6.58533 15.5896 6.91075C15.915 7.23617 15.915 7.76383 15.5896 8.08925L10.5896 13.0893C10.2642 13.4147 9.73649 13.4147 9.41108 13.0893L4.41107 8.08925C4.08563 7.76383 4.08563 7.23617 4.41107 6.91075Z"
              fill={showMenu ? "#23D8F0" : "#9B9B9B"}
            />
          </svg>
        </div>
      ) : (
        <img src='/icon/Language.png' alt="" style={{ width: "24px", height: "24px" }} />
      )}

      {showMenu && (
        <div className="child" onMouseEnter={() => setShowMenu(true)}>
          {textList.map((item, index) => (
            <div key={index} className="item" onClick={(e) => { e.stopPropagation(); handleChildMenuAction(index); }}>
              {item}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;